import { formatAgentName, userCache } from "@/shared-utils";

import { useAgentStore } from "../store";

/** return friendly name for agent -
 * prefer returning first name from sso, fallback to use name from agent sdk (i.e. prefer John vs JOHN.DOE formatted to John Doe) */
export function useAgentFriendlyName() {
    const agentName = useAgentStore((state) => formatAgentName(state.agentName));
    const expertName = userCache.givenName ?? agentName;
    return expertName ?? agentName;
}
